import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Select } from "@activecollab/components";
import PropTypes from "prop-types";
import { addTaskList } from "~/store/actions/actions.taskLists.jsx";
import { getTaskListsByProjectIdForColumnView } from "~/store/selectors/selector.taskLists.jsx";

export const SelectTaskList = ({ onChange, projectId, ...rest }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const taskLists = useSelector((state) => getTaskListsByProjectIdForColumnView(state, projectId));

  const handleChange = useCallback(
    (value) => {
      typeof onChange === "function" && onChange({ task_list_id: value });
    },
    [onChange]
  );

  const handleOnAddNew = useCallback(
    (name) => {
      dispatch(addTaskList(projectId, { name })).then((data) => {
        const { response = {} } = data;
        const { result = {} } = response;
        const { single: id } = result;

        typeof onChange === "function" && onChange({ task_list_id: id });
      });
    },
    [onChange, dispatch, projectId]
  );

  return (
    <Select
      {...rest}
      onChange={handleChange}
      emptyValue={t("Add new")}
      emptyAction={handleOnAddNew}
      options={taskLists}
      autoHeightMax={278}
      disabledInternalSort
      keepSameOptionsOrder
    />
  );
};

SelectTaskList.propTypes = {
  onChange: PropTypes.func,
  projectId: PropTypes.number,
};
